module.exports = __webpack_public_path__ + "static/media/tournament-thumb-9ball.84468f0c.png";